import { lazy, Suspense } from 'react';


const components: { [key: string]: React.ComponentType<any> } = {
    hero: lazy(() => import('components/Hero')),
    promo: lazy(() => import('components/Promo')),
    infoSteps: lazy(() => import('components/InfoSteps')),
    compare: lazy(() => import('components/Compare')),
    faq: lazy(() => import('components/Faq')),
    hero2: lazy(() => import('components/Hero2')),
    mediaSection: lazy(() => import('components/MediaSection')),
    mediaBlock: lazy(() => import('components/Mediablock')),
    content: lazy(() => import('components/Content')),
    spacer: lazy(() => import('components/Spacer')),
    indentedBlock: lazy(() => import('components/IndentedBlock'))
}

const missingBlockTypes = new Set<string>();


export default function BlockRenderer({ blocks }: { blocks: any }) {
    return (
        <Suspense fallback={<></>}>
            {blocks?.map((block: any, index: number) => {
                if (block.blockType === 'hero') {
                    const asSeenOn = blocks.find((b: any) => b.blockType === 'asSeenOn');
                    if (asSeenOn) {
                        block.asSeenOn = asSeenOn;
                    }
                }

                const Block = components[block.blockType];
                if (!Block) {
                    if (!missingBlockTypes.has(block.blockType)) {
                        console.error(`No component found for block type: ${block.blockType}`);
                        missingBlockTypes.add(block.blockType);
                    }
                    return null;
                }
                if (!block) {
                    console.error(`Block data is null or undefined at index: ${index}`);
                    return null;
                }

                return (
                    <Suspense key={index} fallback={<></>}>
                        <Block {...block} />
                    </Suspense>
                );
            })}
        </Suspense>
    )
}
